import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CommonUri from "../../common/uri/common-uri.constants";

@Component({
    name: "LanguageSelectComponent",
    render: function(createElement) {
        if (!this.template) {
            return createElement("span", "Loading...");
        } else {
            return this.template();
        }
    },
    created() {
        switch (this.type) {
            case "radio":
                this.template = Vue.compile(
                    require("./template.radio.html")
                ).render;
                break;
            case "select":
                this.template = Vue.compile(
                    require("./template.select.html")
                ).render;
                break;
            default:
                this.template = Vue.compile(require("./template.html")).render;
        }
    }
})
class LanguageSelectComponent extends Vue {
    @Prop({ default: "dropdown" })
    type: string;

    @Prop({ type: [Number, String] })
    value;

    @Prop({ default: false })
    allowDe: boolean;

    @Prop({ default: false, type: [Boolean] })
    icon;

    @Prop({ default: false })
    disabled: boolean;

    dtValue: any;

    get CurrentLanguage() {
        if (!this.value || this.value == null) {
            this.dtValue = this.allowLocales[0].code;
        } else {
            this.dtValue = this.value;
        }

        return this.allowLocales.find(l => {
            return l.code === this.dtValue || l.id === this.dtValue;
        });
    }

    get CurrentLanguageCode() {
        return this.CurrentLanguage.code;
    }

    getFlagUrl(langCode) {
        switch (langCode) {
            case "nl-BE":
                return CommonUri.netherlandsFlag;
            case "fr-BE":
                return CommonUri.franceFlag;
            case "en-US":
                return CommonUri.unitedKingdomFlag;
            case "de-DE":
                return CommonUri.germanyFlag;
        }
    }

    set CurrentLanguageCode(value: any) {
        const item = this.allowLocales.find(l => {
            return l.code === value;
        });

        this.handleCommand({ item });
    }

    handleCommand(command) {
        if (this.disabled) return;

        if (typeof this.dtValue === "number") {
            this.dtValue = command.item.id;
            this.$emit("update:value", command.item.id);
            this.$emit("input", command.item.id);
            this.$emit("change", command.item.id);
        } else {
            this.dtValue = command.item.code;
            this.$emit("update:value", command.item.code);
            this.$emit("input", command.item.code);
            this.$emit("change", command.item.code);
        }
    }

    get coFlag() {
        return this.CurrentLanguage ? this.CurrentLanguage.flag : "";
    }

    constructor() {
        super();
        this.dtValue = this.value;
    }

    get allowLocales() {
        return Vue.config["locales"];
    }

    mounted() {
        if (!this.value) {
            this.dtValue = this.$i18n.locale;
        }
    }
}

export default LanguageSelectComponent;
